import { baseQuery } from '../baseQuery';
import env from 'env';
import { SuggestionsRequest, SuggestionsResponse } from 'types/ai';

export const postSuggestions = async (payload: SuggestionsRequest): Promise<SuggestionsResponse> => {
  return await baseQuery('suggestions', {
    type: 'POST',
    body: payload,
    api: env.AI_API_SERVER,
  });
};
